import React from 'react';
import { useTranslation } from 'react-i18next';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  SelectDropDown,
  DatePicker
} from 'components/common/Elements/Elements';

import { createFilterCountry, createFilterSize } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  trigerResetDatePicker,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 12;
  let cancellationsCountry = [];
  let companySize = [];

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  function checkAndSetFilter(key, value) {
    if (!isEqual(filter[key], value)) {
      setFilter({ ...filter, [key]: value, currentPage: 1 });
      // in cross filters after changing the date you need to get new filters
      setStartFilter(!startFilter);
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
  }

  const handleDateRequestedAt = value => {
    const key = 'requestedAt';
    checkAndSetFilter(key, value);
  };
  const handleDateNextBillingAt = value => {
    const key = 'nextBillingAt';
    checkAndSetFilter(key, value);
  };
  const handleDateRequestRemovedAt = value => {
    const key = 'requestRemovedAt';
    checkAndSetFilter(key, value);
  };

  (function () {
    createFilterCountry(filters.countryCode, cancellationsCountry);
    createFilterSize(filters.companySize, companySize);
  })();

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={filters.status}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.CUSTOMER_STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.healthStatus}
        input={{ value: filter.healthStatus, onChange: handleFilter }}
        name={'healthStatus'}
        label={t('activity:filters.HEALTH_STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={companySize}
        input={{ value: filter.companySize, onChange: handleFilter }}
        name={'companySize'}
        label={t('activity:filters.COMPANY_SIZE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.plan}
        input={{ value: filter.plan, onChange: handleFilter }}
        name={'plan'}
        label={t('activity:filters.PRICING_PLAN')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.billingCycle}
        input={{ value: filter.billingCycle, onChange: handleFilter }}
        name={'billingCycle'}
        label={t('activity:filters.BILLING_CYCLE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.cancellationReason}
        input={{ value: filter.cancellationReason, onChange: handleFilter }}
        name={'cancellationReason'}
        label={t('activity:filters.CANCELLATION_REASON')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.accountManager}
        input={{ value: filter.accountManager, onChange: handleFilter }}
        name={'accountManager'}
        label={t('activity:filters.ACCOUNT_MANAGER_')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.customerSuccessEngineer}
        input={{
          value: filter.customerSuccessEngineer,
          onChange: handleFilter
        }}
        name={'customerSuccessEngineer'}
        label={t('activity:about.CS_ENGINEER')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <DatePicker
        label={t('activity:filters.CREATED_DATE')}
        input={{
          value: filter.requestedAt,
          onChange: handleDateRequestedAt
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <DatePicker
        label={t('activity:filters.NEXT_BILLING')}
        input={{
          value: filter.nextBillingAt,
          onChange: handleDateNextBillingAt
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <DatePicker
        label={t('activity:filters.REQUEST_TO_REMOVE')}
        input={{
          value: filter.requestRemovedAt,
          onChange: handleDateRequestRemovedAt
        }}
        trigerResetDatePicker={trigerResetDatePicker}
      />
      <SelectDropDown
        options={filters.requestedByRole}
        input={{ value: filter.requestedByRole, onChange: handleFilter }}
        name={'requestedByRole'}
        label={t('activity:filters.ROLE')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  filters: PropTypes.object,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
